export default __webpack_public_path__ + "static/media/page-not-found.955813e5.svg";